import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    mix: translate({ id: 'order.form.bulk.mixed' }),
    title: translate({ id: 'recurrenceSettings.bulk.recurrenceType.recurrenceTitle' }),
    recurrence: translate({ id: 'recurrenceSettings.bulk.recurrenceType.recurrence' }),
    date: translate({ id: 'recurrenceSettings.bulk.recurrenceType.date' }),
    noRepeat: translate({ id: 'recurrenceSettings.recurrenceType.option.noRepeat' }),
    daily: translate({ id: 'recurrenceSettings.recurrenceType.option.daily' }),
    weekly: translate({ id: 'recurrenceSettings.recurrenceType.option.weekly' }),
    monthly: translate({ id: 'recurrenceSettings.recurrenceType.option.monthly' }),
    annually: translate({ id: 'recurrenceSettings.recurrenceType.option.annually' }),
  }))

  return api
}
